import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(): Promise<Optional<Language[]>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Language`;
	return axios.get(url).toOptionalMapped((x) => x.data.languages);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	languages: Language[];
};

export type Language = {
	id: string;
	sortOrder: number;
	name: string;
	cultureCode: string;
	hasArticleBeforeIngredientName: boolean;
};
